import EMRService from './../services/emr.service'

// action types
export const GET_PATIENT = 'GetPatient'
export const PURGE_PATIENT = 'PurgePatient'

// mutation types
export const SET_PATIENT = 'SetPatient'
export const DESTROY_PATIENT = 'DestroyPatient'
export const SET_ERROR = 'SetError'

// state
const state = {
  errors: null,
  patientDetails: {}
}

// getters
const getters = {
  currentPatient (state) {
    return state.patientDetails
  }
}

// actions
const actions = {
  [GET_PATIENT] (context, patientNo) {
    return new Promise((resolve, reject) => {
      EMRService.get(patientNo)
        .then(response => {
          console.log(response.data.data)
          response.data.data.patient.id = patientNo
          context.commit(SET_PATIENT, response.data)
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
          context.commit(SET_ERROR, e)
        })
    })
  },

  [PURGE_PATIENT] (context) {
    context.commit(DESTROY_PATIENT)
  }
}

// mutations
const mutations = {
  [SET_ERROR] (state, error) {
    state.errors = error
  },

  [SET_PATIENT] (state, data) {
    state.patientDetails = data.data.patient
    state.errors = {}
  },

  [DESTROY_PATIENT] (state) {
    state.patientDetails = {}
    state.billDetails = {}
    state.transactionDetails = {}
    state.errors = {}
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/welcome.module.js